import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './component/layout/auth/auth.component';
import { AdminPanelComponent } from './component/layout/admin-panel/admin-panel.component';
import { AuthGuard } from './core/auth/auth.guard';
import { APP_ROUTES } from './core/constants/app-routes';
import { LoginGuard } from './core/auth/login.guard';
import { AdminGuard } from './core/auth/admin.guard';

const routes: Routes = [
    {
        path: APP_ROUTES.auth.base,
        component: AuthComponent,
        canActivate: [LoginGuard],
        children: [
            {
                path: APP_ROUTES.auth.login,
                loadComponent: () => import('@views/pages/login/login.component').then(m => m.LoginPage),
            },
            {
                path: APP_ROUTES.auth.forgotPassword,
                loadComponent: () => import('@views/pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordPage),
            },
            {
                path: APP_ROUTES.auth.resetPassword,
                loadComponent: () => import('@views/pages/reset-password/reset-password.component').then(m => m.ResetPasswordPage),
            },
        ]
    },
    {
        path: APP_ROUTES.employer.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard, AdminGuard], 
        children: [
            {
                path: '',
                redirectTo: APP_ROUTES.employer.list,
                pathMatch: 'full'
            },
            {
                path: APP_ROUTES.employer.list,
                loadComponent: () => import('@views/pages/employer/employer-list.component').then(m => m.EmployerListPage),
            },
            {
                path: APP_ROUTES.employer.details,
                loadComponent: () => import('@views/pages/employer/single/employer-details.component').then(m => m.EmployerDetailsPage),
            },
        ]
    },
    { // Agent Routes
        path: APP_ROUTES.agent.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard, AdminGuard],
        children: [
            {
                path: '',
                redirectTo: APP_ROUTES.agent.list,
                pathMatch: 'full'
            },
            {
                path: APP_ROUTES.agent.list,
                loadComponent: () => import('@views/pages/agent/agent-list.component').then(m => m.AgentListPage),
            },
            {
                path: APP_ROUTES.agent.details,
                loadComponent: () => import('@views/pages/agent/single/agent-details.component').then(m => m.AgentDetailsPage),
            },
        ]
    },
    {
        // Admin Routes
        path: APP_ROUTES.admin.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard, AdminGuard], 
        children: [
            {
                path: '',
                redirectTo: APP_ROUTES.admin.list,
                pathMatch: 'full'
            },
            {
                path: APP_ROUTES.admin.list,
                loadComponent: () => import('@views/pages/admin/admin-list.component').then(m => m.AdminsListPage),
            },
            {
                path: APP_ROUTES.admin.details,
                loadComponent: () => import('@views/pages/admin/single/admin-details.component').then(m => m.AdminDetailsPage),
            },
        ]
    },
    {

        path: APP_ROUTES.payroll.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard, AdminGuard], 
        children: [
            {
                path: '',
                redirectTo: APP_ROUTES.payroll.list,
                pathMatch: 'full'
            },
            {
                path: APP_ROUTES.payroll.list,
                loadComponent: () => import('@views/pages/actuals/actuals.component').then(m => m.ActualsComponent),
            },
            {
                path: APP_ROUTES.payroll.add,
                loadComponent: () => import('@views/pages/actuals/add-payroll/add-payroll.component').then(m => m.AddPayrollComponent),
            },
               {
                path: APP_ROUTES.payroll.edit+"/"+APP_ROUTES.payroll.details,
                loadComponent: () => import('@views/pages/actuals/add-payroll/add-payroll.component').then(m => m.AddPayrollComponent),
            },
        ]
    },
    {
        path: APP_ROUTES.settings.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('@views/pages/settings/settings.component').then(m => m.SettingsComponent),
            }
        ]
    },
    {

        path: APP_ROUTES.commissions.base,
        component: AdminPanelComponent,
        canActivate: [AuthGuard], 
        children: [
            {
                path: '',
                redirectTo: APP_ROUTES.commissions.list,
                pathMatch: 'full'
            },
            {
                path: APP_ROUTES.commissions.list,
                loadComponent: () => import('@views/pages/commissions/commissions.component').then(m => m.CommissionsComponent),
            },
             {
                path: APP_ROUTES.commissions.details,
                loadComponent: () => import('@views/pages/commissions/details/commission-details.component').then(m => m.CommissionDetailsComponent),
            },
            {
                path: APP_ROUTES.commissions.subemployerCommissions,
                loadComponent: () => import('@views/pages/commissions/subemployer/subemployer-commission.component').then(m => m.CommissionDetailsComponent),
            },
            {
                path: APP_ROUTES.commissions.employeeCommissions,
                loadComponent: () => import('@views/pages/commissions/employee/employee-commission.component').then(m => m.CommissionDetailsComponent),
            },
           
        ]
    },
    { path: APP_ROUTES.fallback.default, redirectTo: `${APP_ROUTES.auth.base}/${APP_ROUTES.auth.login}`, pathMatch: 'full' },
    { path: APP_ROUTES.fallback.notFound, redirectTo: `${APP_ROUTES.auth.base}/${APP_ROUTES.auth.login}` }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }